import { values } from 'lodash-es';

import type { LookoRouteObject } from '../LookoRouteObject';

export const 세컨솔드_관리_페이지_라우터 = {
  index: {
    path: '/acloset',
    handle: {
      title: '세컨솔드(에이클로젯)\n관리',
    },
  } satisfies LookoRouteObject,

  판매_정산: {
    path: '/acloset/settlement',
    async lazy() {
      const { default: Page } = await import('@/app/settlement/acloset/AclosetSettlementPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '판매 정산',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  프로필_설정: {
    path: '/acloset/profile',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/프로필_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '프로필 설정',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  쿠폰_관리: {
    path: '/acloset/coupon',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/쿠폰_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '쿠폰 관리',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  할인요청_설정: {
    path: '/acloset/discount-offer',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/할인_요청_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '할인요청 설정',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,

  쿠폰_생성하기: {
    path: '/acloset/coupon/create',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/쿠폰_생성하기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '쿠폰 생성하기',
    },
  } satisfies LookoRouteObject,

  알림_카톡받기: {
    path: '/acloset/purchase-kakao-alarm',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/알림_카톡받기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '주문/문의 알림 카톡받기',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
  현장결제_파트너샵_설정: {
    path: '/acloset/partner-shop-setting',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/현장결제_파트너샵_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '오프라인 매장 홍보하기',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
  방해_고객_관리: {
    path: '/acloset/black-consumers-management',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/방해_고객_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '방해 고객 관리',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
  배송_공지사항_설정: {
    path: '/acloset/shipping-notice',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/배송_공지사항_설정_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '배송 공지사항',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
  리뷰_관리: {
    path: '/acloset/review',
    async lazy() {
      const { default: Page } = await import('@/router/acloset-management/리뷰_관리_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '리뷰 관리',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};
const 세컨솔드_관리_라우터: LookoRouteObject[] = values(세컨솔드_관리_페이지_라우터);

export default 세컨솔드_관리_라우터;
